"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base64 = exports.Encrypt256 = void 0;
var crypto_1 = __importDefault(require("crypto"));
var fs_1 = __importDefault(require("fs"));
var ALGORITHM = 'aes-256-ctr';
var Encrypt256 = /** @class */ (function () {
    function Encrypt256(salt) {
        if (salt === void 0) { salt = 'saltySeaSaltSecret'; }
        this.key = crypto_1.default.createHash('sha256')
            .update(String(salt))
            .digest('base64')
            .substr(0, 32);
        console.log('created new key', this.key);
    }
    Encrypt256.prototype.encrypt = function (buffer) {
        var initializationVector = crypto_1.default.randomBytes(16);
        var cipher = crypto_1.default.createCipheriv(ALGORITHM, this.key, initializationVector);
        var result = Buffer.concat([
            initializationVector,
            cipher.update(buffer),
            cipher.final()
        ]);
        return result;
    };
    ;
    Encrypt256.prototype.decrypt = function (encrypted) {
        var initializationVector = encrypted.slice(0, 16);
        encrypted = encrypted.slice(16);
        var decipher = crypto_1.default.createDecipheriv(ALGORITHM, this.key, initializationVector);
        var result = Buffer.concat([
            decipher.update(encrypted),
            decipher.final()
        ]);
        return result;
    };
    ;
    return Encrypt256;
}());
exports.Encrypt256 = Encrypt256;
var Base64 = /** @class */ (function () {
    function Base64() {
    }
    Base64.toB64String = function (filePath) {
        try {
            var binaryData = fs_1.default.readFileSync(filePath);
            var buffer = Buffer.from(binaryData);
            return buffer.toString('base64');
        }
        catch (error) {
            console.log("Unable to perform Base64 encode: " + filePath);
            console.error(error);
        }
    };
    return Base64;
}());
exports.Base64 = Base64;
